import "react-phone-input-2/lib/style.css";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { BsEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import Auth from "../../layout/Auth";
import Button from "../../common/Button";
import Input from "../../common/Input";
import Api from "../../api/api";
import toast from "react-hot-toast";

const initialData = {
  name: "name",
  fname: "",
  lname: "",
  email: "",
  password: "",
  confirmPassword: "",
};

const Signup = () => {
  const history = useHistory();
  const [isDisable, setIsDisable] = useState(false);
  const [show, setShow] = useState(false);
  const [data, setData] = useState({ ...initialData });

  const handleChange = e => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  const submitHandle = async e => {
    e.preventDefault();

    if (data.password !== data.confirmPassword) {
      return toast.error("Password doesn't match");
    }

    setIsDisable(true);
    try {
      let { confirmPassword, ..._data } = data;
      const res = await Api.signup({ ..._data, isNew: false });
      if (res.status === 200) {
        history.replace("/auth/signin");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsDisable(false);
    }
  };

  useEffect(() => {
    return () => {
      setData({ ...initialData });
      setIsDisable(false);
    };
  }, []);

  return (
    <Auth
      title="Create an account"
      submitHandle={submitHandle}
    >
      <div className="flex items-center justify-between flex-wrap">
        <div className="w-full md:w-[48%]">
          <Input
            title="First Name"
            name="fname"
            value={data.fname}
            onChange={handleChange}
            placeholder="First Name"
            required
          />
        </div>
        <div className="w-full md:w-[48%]">
          <Input
            title="Last Name"
            name="lname"
            value={data.lname}
            onChange={handleChange}
            placeholder="Last Name"
            required
          />
        </div>
      </div>
      <Input
        title="email"
        type="email"
        name="email"
        value={data.email}
        onChange={handleChange}
        placeholder="youremail@example.com"
        required
      />

      <Input
        title="password"
        name="password"
        value={data.password}
        onChange={handleChange}
        type={show ? "text" : "password"}
        placeholder="Password"
        required
      >
        <span
          className="absolute cursor-pointer w-fit right-4 top-[32px]"
          onClick={() => setShow(prev => !prev)}
        >
          {!show ? (
            <BsEyeFill
              fill="var(--primary)"
              size={22}
            />
          ) : (
            <BsFillEyeSlashFill
              fill="var(--primary)"
              size={22}
            />
          )}
        </span>
      </Input>

      <Input
        title="Confirm Password"
        name="confirmPassword"
        value={data.confirmPassword}
        onChange={handleChange}
        type={show ? "text" : "password"}
        placeholder="Confirm Password"
      >
        <span
          className="absolute cursor-pointer w-fit right-4 top-[32px]"
          onClick={() => setShow(prev => !prev)}
        >
          {!show ? (
            <BsEyeFill
              fill="var(--primary)"
              size={22}
            />
          ) : (
            <BsFillEyeSlashFill
              fill="var(--primary)"
              size={22}
            />
          )}
        </span>
      </Input>

      <br />

      <Button
        className="w-full"
        type="submit"
        disabled={isDisable}
      >
        Create Account
      </Button>

      <p className="mt-5 text-center opacity-80 font-medium">
        Already have an account?{" "}
        <Link
          to="/auth/signin"
          className="hover:text-primary"
        >
          Login Here
        </Link>
      </p>
    </Auth>
  );
};

export default Signup;
